import React, { useState } from 'react';
import { ArrowLeft, Star, Award, Users, X, ChevronLeft, ChevronRight, GraduationCap, Heart, MessageCircle, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SuccessStoriesPage = () => {
  const navigate = useNavigate();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [currentGroup, setCurrentGroup] = useState(null);

  const stats = [
    { value: '90%', label: 'Grades 8-9', color: '#FFD700' },
    { value: '100%', label: 'Foundation Grade 5+', color: '#C5A059' },
    { value: '12+', label: 'Years Experience', color: '#3B82F6' },
  ];

  const successStories = [
    {
      id: 'anja',
      student: 'Anja',
      parent: 'Martina',
      grades: ['Grade 5 - Foundation Maths', 'Now eligible for Higher Paper!'],
      highlight: '🔥 3.5 Months Transformation!',
      color: '#C5A059',
      tag: 'LATEST - Jan 2026',
      tagColor: '#C5A059',
      summary: 'From failing to passing in just 3.5 months of intensive tutoring. Now ready for Higher paper in May/June 2026!',
      isNew: true,
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_gcsemath/artifacts/u565bhxk_Screenshot_20260122_130004_WhatsApp.jpg',
          caption: "Martina's WhatsApp message celebrating Anja's Grade 5 success!"
        }
      ]
    },
    {
      id: 'james',
      student: 'James Hocking',
      parent: 'Gayle Hocking',
      grades: ['Grade 9 - Maths', 'Grade 9 - Biology', 'Grade 9 - Chemistry', 'Grade 9 - Physics'],
      highlight: '4 Grade 9s!',
      color: '#FFD700',
      tag: 'Higher Tier',
      summary: 'Tutored since Year 9, now studying A-Level Biology & Chemistry',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/34bvh00l_Screenshot_20260112_004849_Gallery.jpg',
          caption: "James's amazing GCSE results - 9s across the board!"
        },
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/dvfr81tg_Screenshot_20260112_000332_Gmail.jpg',
          caption: 'James sharing his excitement with Dr. Michael'
        },
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/62skrjlr_Screenshot_20260111_235948_Gmail.jpg',
          caption: "Dr. Michael's proud response to James"
        },
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/dvxy8tyt_Screenshot_20260112_000104_Gmail.jpg',
          caption: "Gayle Hocking (James's mum) thanking Dr. Michael"
        }
      ]
    },
    {
      id: 'inaya',
      student: 'Inaya Defise',
      parent: 'Vanessa Defise',
      grades: ['Grade 9 - Maths', 'Grade 9 - Biology', 'Grade 9 - English Lang', 'Grade 9 - English Lit', 'Grade 9 - Religious Studies', 'Grade 9 - Spanish', 'Grade 8 - Chemistry', 'Grade 8 - Physics'],
      highlight: '6 Grade 9s + 4 Grade 8s!',
      color: '#FFD700',
      tag: 'Higher Tier',
      summary: 'Outstanding results across all subjects',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/v74g2s3x_Screenshot_20260112_000658_Gmail.jpg',
          caption: "Vanessa sharing Inaya's incredible results"
        },
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/o0ag0xb4_Screenshot_20260112_000638_Gmail.jpg',
          caption: "Inaya's full results breakdown"
        }
      ]
    },
    {
      id: 'henry',
      student: 'Henry',
      parent: 'Candida',
      grades: ['8 Grade 9s including Maths & all Sciences'],
      highlight: '8 Grade 9s!',
      color: '#FFD700',
      tag: 'Higher Tier',
      summary: 'Exceptional performance across the board',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/4mt8mx2c_Screenshot_20260112_002107_Gmail.jpg',
          caption: "Candida celebrating Henry's 8 Grade 9s"
        }
      ]
    },
    {
      id: 'daniel',
      student: 'Daniel',
      parent: 'Mrs Dang',
      grades: ['Grade 8 - Maths (1 mark off a 9!)'],
      highlight: '1 Mark Off Grade 9!',
      color: '#C0C0C0',
      tag: 'Higher Tier',
      summary: 'So close to perfection - requesting a remark!',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/anyvly50_Screenshot_20260112_000032_Gmail.jpg',
          caption: "Mrs Dang sharing Daniel's near-perfect result"
        },
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/ssa2zwqy_Screenshot_20260112_000126_Gmail.jpg',
          caption: "The journey to Grade 8 - just 1 mark off a 9!"
        }
      ]
    },
    {
      id: 'alex',
      student: 'Alex',
      parent: 'Kelly Pemberton',
      grades: ['Grade 8 - Maths', '3 A*s', '4 As', '3 Bs'],
      highlight: 'Now doing A-Level Maths!',
      color: '#C0C0C0',
      tag: 'Higher Tier',
      summary: 'Progressing to A-Level Mathematics',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/avnvze9n_Screenshot_20260112_000421_Gmail.jpg',
          caption: "Kelly celebrating Alex's results and progression to A-Levels"
        }
      ]
    },
    {
      id: 'kamau',
      student: 'Kamau',
      parent: 'Ms Ashanti (Malaika)',
      grades: ['Grade 7 - Maths', 'Grade 6 - Physics'],
      highlight: 'SEN Success Story',
      color: '#C5A059',
      tag: 'SEN Student',
      tagColor: '#C5A059',
      summary: 'Overcoming challenges with dedicated support',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/r9n4n8eb_Screenshot_20260112_003831_Gallery.jpg',
          caption: "Ms Ashanti's heartfelt message about Kamau's journey"
        }
      ]
    },
    {
      id: 'sean',
      student: 'Sean',
      parent: 'Angie',
      grades: ['Building Confidence', 'Loving Maths Again'],
      highlight: 'SEN - Confidence Restored',
      color: '#C5A059',
      tag: 'SEN Student',
      tagColor: '#C5A059',
      summary: '"Never heard him so positive about learning"',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/mpqy3e0n_Screenshot_20260112_001933_Gmail.jpg',
          caption: "Angie sharing Sean's newfound love for learning"
        },
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/1stlbam4_Screenshot_20260112_001915_Gmail.jpg',
          caption: "Sean's positive progress with Dr. Michael"
        }
      ]
    },
    {
      id: 'omarie',
      student: 'Omarie',
      parent: 'Kazz',
      grades: ['Grade 5 - Foundation Maths'],
      highlight: 'Retake Success!',
      color: '#3B82F6',
      tag: 'Foundation',
      tagColor: '#3B82F6',
      summary: '"Finally he\'s done it! Your approach worked."',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/7ey7zc5d_Screenshot_20260112_002203_Gmail.jpg',
          caption: "Kazz celebrating Omarie's Foundation success"
        }
      ]
    },
    {
      id: 'marcela',
      student: "Marcela's Son",
      parent: 'Marcela Goonetillake',
      grades: ['Predicted Grade 3 → Achieved Grade 6!'],
      highlight: '3 Grade Improvement!',
      color: '#C5A059',
      tag: 'Transformation',
      tagColor: '#9333EA',
      summary: 'From struggling to succeeding in Biology GCSE',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/t6hdmwk8_1000179213.jpg',
          caption: "Marcela's review - Grade 3 prediction to Grade 6 achievement!"
        }
      ]
    },
    {
      id: 'danielle',
      student: "Danielle's Children",
      parent: 'Danielle Staadecker',
      grades: ['GCSE Maths', 'GCSE Chemistry'],
      highlight: "Can't Recommend Highly Enough!",
      color: '#EC4899',
      tag: '5-Star Review',
      tagColor: '#EC4899',
      summary: '"Absolutely Brilliant tutor... trust him completely"',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/s8vc4puz_1000179193.jpg',
          caption: "Danielle's glowing 5-star recommendation"
        }
      ]
    },
    {
      id: 'seanojo',
      student: 'Sean Ojo',
      parent: null,
      grades: ['Massive Improvement'],
      highlight: 'Student Recommendation',
      color: '#C5A059',
      tag: 'Student Review',
      tagColor: '#C5A059',
      summary: '"I promise you will see an instant change"',
      screenshots: [
        {
          url: 'https://customer-assets.emergentagent.com/job_abba-academy/artifacts/ok3o0xa3_Screenshot_20260112_011737_Facebook.jpg',
          caption: "Sean Ojo's student recommendation on Facebook"
        }
      ]
    }
  ];

  const openLightbox = (groupIndex, imageIndex) => {
    setCurrentGroup(groupIndex);
    setCurrentImage(imageIndex);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setCurrentGroup(null);
    setCurrentImage(0);
  };

  const nextImage = () => {
    const group = successStories[currentGroup];
    setCurrentImage((prev) => (prev + 1) % group.screenshots.length);
  };

  const prevImage = () => {
    const group = successStories[currentGroup];
    setCurrentImage((prev) => (prev - 1 + group.screenshots.length) % group.screenshots.length);
  };

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      {/* Header */}
      <header style={{
        background: 'linear-gradient(135deg, #C5A059 0%, #C5A059 100%)',
        padding: '1.5rem',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <button 
            onClick={() => navigate('/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '0.9rem'
            }}
          >
            <ArrowLeft size={18} />
            Back to Home
          </button>
          <h1 style={{ 
            color: 'white', 
            fontSize: '1.25rem', 
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <Sparkles size={20} />
            Success Stories
          </h1>
          <div style={{ width: '120px' }}></div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="parallax-section" style={{
        backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.88) 0%, rgba(15, 23, 42, 0.85) 100%), url('https://static.prod-images.emergentagent.com/jobs/ee1a1db2-a588-42e0-b44d-7c9f207c1d4b/images/47b133bc4bf14a2f18eea2a7b64ae46f560afa3b5d94ef54d63d113e577df6c0.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        padding: '4rem 1.5rem',
        textAlign: 'center',
        color: 'white'
      }}>
        <h2 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 800, 
          marginBottom: '1rem',
          color: 'white'
        }}>
          Real Messages. Real Results. Real Success.
        </h2>
        <p style={{ 
          color: 'rgba(255,255,255,0.7)', 
          maxWidth: '700px', 
          margin: '0 auto 2rem',
          fontSize: '1.1rem'
        }}>
          See authentic WhatsApp messages and reviews from parents and students celebrating their GCSE achievements with Abba Academy
        </p>

        {/* Stats */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '2rem',
          flexWrap: 'wrap'
        }}>
          {stats.map((stat, index) => (
            <div key={index} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: 800, color: stat.color }}>
                {stat.value}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem' }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Success Stories Grid */}
      <section style={{ padding: '3rem 1.5rem' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '2rem',
            maxWidth: '1400px',
            margin: '0 auto'
          }}>
            {successStories.map((story, groupIndex) => (
              <div 
                key={story.id}
                className="product-card"
                style={{
                  padding: '0',
                  overflow: 'hidden',
                  border: `3px solid ${story.color}`,
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}
              >
                {/* Card Header */}
                <div style={{
                  background: `linear-gradient(135deg, ${story.color}20 0%, ${story.color}10 100%)`,
                  padding: '1.25rem',
                  borderBottom: `1px solid ${story.color}30`
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.75rem' }}>
                    <div>
                      <h3 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.25rem' }}>
                        {story.student}
                      </h3>
                      {story.parent && (
                        <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', margin: 0 }}>
                          Parent: {story.parent}
                        </p>
                      )}
                    </div>
                    <span style={{
                      background: story.tagColor || story.color,
                      color: 'white',
                      padding: '4px 12px',
                      borderRadius: '9999px',
                      fontSize: '0.75rem',
                      fontWeight: 600
                    }}>
                      {story.tag}
                    </span>
                  </div>
                  
                  {/* Highlight Badge */}
                  <div style={{
                    display: 'inline-block',
                    background: story.color,
                    color: story.color === '#FFD700' || story.color === '#C5A059' ? '#1a1a2e' : 'white',
                    padding: '6px 14px',
                    borderRadius: '8px',
                    fontSize: '0.9rem',
                    fontWeight: 700,
                    marginBottom: '0.75rem'
                  }}>
                    🏆 {story.highlight}
                  </div>

                  {/* Grades */}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {story.grades.map((grade, i) => (
                      <span 
                        key={i}
                        style={{
                          background: 'rgba(0,0,0,0.05)',
                          padding: '4px 10px',
                          borderRadius: '6px',
                          fontSize: '0.8rem',
                          color: 'var(--text-body)'
                        }}
                      >
                        {grade}
                      </span>
                    ))}
                  </div>

                  <p style={{ 
                    fontSize: '0.9rem', 
                    color: 'var(--text-secondary)', 
                    marginTop: '0.75rem',
                    fontStyle: 'italic'
                  }}>
                    {story.summary}
                  </p>
                </div>

                {/* Screenshots Grid */}
                <div style={{ padding: '1rem' }}>
                  <p style={{ 
                    fontSize: '0.8rem', 
                    color: 'var(--text-secondary)', 
                    marginBottom: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <MessageCircle size={14} />
                    {story.screenshots.length} Real Message{story.screenshots.length > 1 ? 's' : ''}
                  </p>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: story.screenshots.length > 1 ? 'repeat(2, 1fr)' : '1fr',
                    gap: '0.75rem'
                  }}>
                    {story.screenshots.map((screenshot, imgIndex) => (
                      <div
                        key={imgIndex}
                        onClick={() => openLightbox(groupIndex, imgIndex)}
                        style={{
                          position: 'relative',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          aspectRatio: '3/4',
                          background: '#f0f0f0'
                        }}
                      >
                        <img
                          src={screenshot.url}
                          alt={screenshot.caption}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.2s ease'
                          }}
                          onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                          onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                        />
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                          padding: '2rem 0.75rem 0.75rem',
                          color: 'white',
                          fontSize: '0.75rem'
                        }}>
                          Click to enlarge
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #C5A059 0%, #C5A059 100%)',
        padding: '4rem 1.5rem',
        textAlign: 'center',
        color: 'white'
      }}>
        <h2 style={{ 
          fontSize: '2rem', 
          fontWeight: 700, 
          marginBottom: '1rem',
          color: 'white'
        }}>
          Ready to Write Your Own Success Story?
        </h2>
        <p style={{ 
          color: 'rgba(255,255,255,0.7)', 
          maxWidth: '600px', 
          margin: '0 auto 2rem' 
        }}>
          Join hundreds of students who have achieved their target grades with Dr. Michael Omakobia
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a 
            href="https://calendly.com/drmomakobia/studentcall"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: 'white',
              color: '#C5A059',
              padding: '14px 32px',
              borderRadius: '9999px',
              fontWeight: 700,
              textDecoration: 'none',
              fontSize: '1rem'
            }}
          >
            Schedule Free Call
          </a>
          <button 
            onClick={() => navigate('/')}
            style={{
              background: 'transparent',
              color: 'white',
              padding: '14px 32px',
              borderRadius: '9999px',
              fontWeight: 700,
              border: '2px solid white',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Back to Home
          </button>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxOpen && currentGroup !== null && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.95)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem'
          }}
          onClick={closeLightbox}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: 'rgba(255,255,255,0.1)',
              border: 'none',
              borderRadius: '50%',
              width: '44px',
              height: '44px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: 'white'
            }}
          >
            <X size={24} />
          </button>

          {/* Image Container */}
          <div 
            style={{ 
              maxWidth: '90vw', 
              maxHeight: '85vh',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={successStories[currentGroup].screenshots[currentImage].url}
              alt={successStories[currentGroup].screenshots[currentImage].caption}
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain',
                borderRadius: '12px'
              }}
            />
            
            {/* Caption */}
            <div style={{
              textAlign: 'center',
              color: 'white',
              marginTop: '1rem',
              fontSize: '0.95rem'
            }}>
              <p style={{ margin: '0 0 0.5rem' }}>
                <strong>{successStories[currentGroup].student}</strong>
              </p>
              <p style={{ margin: 0, opacity: 0.8 }}>
                {successStories[currentGroup].screenshots[currentImage].caption}
              </p>
              {successStories[currentGroup].screenshots.length > 1 && (
                <p style={{ margin: '0.5rem 0 0', opacity: 0.6, fontSize: '0.85rem' }}>
                  {currentImage + 1} / {successStories[currentGroup].screenshots.length}
                </p>
              )}
            </div>

            {/* Navigation Arrows */}
            {successStories[currentGroup].screenshots.length > 1 && (
              <>
                <button
                  onClick={(e) => { e.stopPropagation(); prevImage(); }}
                  style={{
                    position: 'absolute',
                    left: '-60px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#FFD700',
                    border: 'none',
                    borderRadius: '50%',
                    width: '44px',
                    height: '44px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  <ChevronLeft size={24} color="#1a1a2e" />
                </button>
                <button
                  onClick={(e) => { e.stopPropagation(); nextImage(); }}
                  style={{
                    position: 'absolute',
                    right: '-60px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#FFD700',
                    border: 'none',
                    borderRadius: '50%',
                    width: '44px',
                    height: '44px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  <ChevronRight size={24} color="#1a1a2e" />
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SuccessStoriesPage;
